import * as React from 'react';

import { InfoBar } from './info-bar';

function Topbar() {
  return (
    <div className="sticky top-0 z-30 hidden text-sm font-bold tracking-wide text-center uppercase bg-white sm:flex sm:items-center sm:py-0 sm:h-12 sm:px-6 lg:px-8">
      <div className="flex flex-wrap items-center justify-between w-full">
        <div className="w-full text-sm font-bold text-center sm:text-left sm:w-auto sm:flex-1">
          Free delivery on all orders over $100 Australia wide
        </div>
        <InfoBar />
      </div>
    </div>
  );
}

export { Topbar };
